import {runElectronFunc} from "./comm";

function showNoti(targetWindowId) {
    runElectronFunc('ElectronWindowApi', 'openFlashFrame', targetWindowId && targetWindowId !== 'noti_post' ? ("POPUP_CHAT_" + targetWindowId) : "MAIN" );
}

function hideNoti(targetWindowId) {
    if (!ElectronApi.Comm.isElectronApp()) return;
    runElectronFunc('ElectronWindowApi', 'hideFlashFrame', targetWindowId ? ("POPUP_CHAT_" + targetWindowId) : "MAIN");
}

export {
    showNoti,
    hideNoti,
};
